<template>
    <div v-if="error" class="text-danger mb-2">
                    {{ error }}
    </div>
    <div v-if="message" class="container-fluid" >
        <div class="alert alert-secondary" role="alert">
            {{ message }}
        </div>
    </div>
    <div class="row mx-3" v-if="credentialList.length > 0 || dropDownLoading === 'credential' || selectedBucket" :class="dropDownDisable?'dropDownMenu':''">
        <div v-if="credentialOptions.length>0 || dropDownLoading=='credential'" class="col-md-6 col-lg-3 mb-2">
            <label class="form-label">Choose a Credential <span class="text-danger">&nbsp;*</span></label>
            <select v-if="credentialOptions.length>0" class="form-select form-control" v-model="selectedCredential">
                    <option v-for="option in credentialOptions" :key="option.value" :value="option.value">
                        {{ option.label }}
                    </option>
            </select>
            <div v-else class="spinner-border spinner-border-sm loader">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div v-if="bucketOptions.length>0 || dropDownLoading=='bucket'" class="col-md-6 col-lg-3 mb-2">
            <label class="form-label">Choose a bucket <span class="text-danger">&nbsp;*</span></label>
            <select v-if="bucketOptions.length>0" class="form-select form-control" @change="onSelectBucket($event.target.value)" v-model="selectedBucket">
                    <option v-for="option in bucketOptions" :key="option.value" :value="option.value">
                        {{ option.label }}
                    </option>
            </select>
            <div v-else class="spinner-border spinner-border-sm loader ">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div v-if="selectedCredential" class="col text-end" >
            <button style="margin-top: 28px" :disabled="loading" type="button" @click="onRefresh()" class="btn lift btn-primary float-right" ><i class="fa fa-refresh"/></button>
        </div>
    </div>
    <div v-if="selectedBucket" class="mx-4 my-3">
        <Breadcrumbs :breadcrumbItems="this.$store.state.breadcrumbs" :key="this.$store.state.breadcrumbs.length" :showRoute="false" @onBreadcrumbClick="onBreadcrumbClick"/>
        <FolderView
            tableId="fileBrowserTable"
            :data="filesList" baseUrl=''
            :loading="loading"
            name='File Browser Folder'
            identifier='folderName' icon='folder'
            @fetchSubFolder="fetchSubFolder"
            @selectedFiles="selectedFiles"/>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import FolderView from "../../components/FolderView.vue";
import Breadcrumbs from "../../components/Breadcrumbs.vue";

const SERVICE_NAME = 'surface';

export default {
    components: { FolderView, Breadcrumbs },
    data() {
        return {
            bucketList: [],
            filesList: [],
            credentialList: [],
            loading: true,
            dropDownLoading: '',
            selectedBucket: null,
            selectedCredential: null,
            error: null,
            message: null,
            presignURL: null
        };
    },
    props: {
        generateURL: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        credentialOptions() {
            return this.credentialList.map(ns => ({ label: ns, value: ns }));
        },
        bucketOptions() {
            if (this.bucketList && this.bucketList.length > 0) {
                return this.bucketList.map((bucket) => ({ label: bucket.name, value: bucket.name }));
            }
            return [];
        },
        folderPath() {
            return this.$store.state.amdp.folderPath;
        },
        dropDownDisable() {
            return this.dropDownLoading != '';
        },
        currentCid() {
            return this.$store.state.currentClient?.cid;
        }
    },
    watch: {
        async selectedCredential(newValue) {
            if (newValue && newValue != "") {
                this.dropDownLoading = "bucket";
                this.message = null;
                this.error = null;
                this.selectedBucket = '';
                this.$store.dispatch('setBreadcrumbs', []);
                this.bucketList = [];
                this.$store.dispatch('amdp/setSelectedCredential', newValue);
                await this.fetchBucketList();
            }
        },
        selectedBucket(to, from) {
            if (to && ((!from && !to) || (from !== to))) {
                this.setFolderPathAndFetchFielList();
            }
        },
        filesList() {
            this.filesList.map((file) => {
                file['folderName'] = file.name.replace("/", '');
            });
        },
        currentCid(newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
                this.selectedCredential = null;
                this.credentialList = [];
                this.selectedBucket = null;
                this.bucketList = [];
                this.filesList = [];
                this.error = null;
                this.message = null;
                this.$store.dispatch('setBreadcrumbs', []);
                this.$store.dispatch('amdp/setFolderPath', '');
                this.fetchNamespaces();
            }
        }
    },
    methods: {
        ...mapActions({
            getServiceBucketList: "amdp/getServiceBucketList",
            getServiceFileBrowserList: "amdp/getServiceFileBrowserList",
            getServicePresignURL: "amdp/getServicePresignURL",
            getServiceNamespaces: "amdp/getServiceNamespaces",
        }),
        async fetchNamespaces() {
            this.dropDownLoading = 'credential';
            this.loading = true;
            try {
                const response = await this.getServiceNamespaces(SERVICE_NAME);
                this.credentialList = response.data || [];
                if (!this.credentialList.length) {
                    this.message = 'No credentials available for service.';
                } else {
                    this.selectedCredential = this.credentialList[0];
                }
            } catch (e) {
                this.error = e.response?.data?.error || e.message;
            } finally {
                this.dropDownLoading = '';
                this.loading = false;
            }
        },
        fetchSubFolder(subFolderId) {
            this.setFolderPathAndFetchFielList(subFolderId);
        },
        setFolderPathAndFetchFielList(subFolderId) {
            let path = this.folderPath;
            let refresh = false;
            if (path === "" || path.endsWith("@") || path.endsWith("@/") || !subFolderId) {
                let credential = this.$store.state.amdp.selectedCredential;
                path = "s3://" + (credential ? this.$store.state.currentClient.cid + '.' + credential + '@' : '') + this.selectedBucket + "/";
                refresh = true;
            } else if (subFolderId) {
                path = path + subFolderId + "/";
                refresh = true;
            }
            if (refresh) {
                this.$store.dispatch('amdp/setFolderPath', path.replace("slash/", "/").replace("///", "//"));
                this.filesList = [];
                this.fetchFileBrowserList(this.folderPath);
            }
        },
        selectedFiles(selectedFile) {
            if (selectedFile) {
                if (selectedFile.is_dir === "false") {
                    const s3Path = this.buildS3Path(selectedFile.name);
                    this.$emit('onFileClicked', { name: s3Path });
                    if (this.generateURL || selectedFile.name.endsWith('.json') || selectedFile.name.endsWith('.csv')) {
                        this.fetchPresignURL(s3Path);
                    } else {
                        this.$emit('onFileSelect', { presignedUrl: null, name: s3Path });
                    }
                }
            }
        },
        async fetchBucketList(refresh = false) {
            let response;
            this.loading = true;
            this.error = null;
            if (refresh) {
                this.dropDownLoading = 'bucket';
            }
            try {
                let param = {
                    serviceName: SERVICE_NAME,
                    namespace: this.selectedCredential,
                    type: "s3",
                    credential: this.$store.state.currentClient.cid + "." + this.selectedCredential
                };
                response = await this.getServiceBucketList(param);
            } catch (error) {
                if (error.response?.data?.error) this.error = error.response.data.error;
                else this.error = error.message;
                this.dropDownLoading = '';
                this.$store.dispatch('setBreadcrumbs', []);
                this.loading = false;
                return;
            }
            this.bucketList = response.data || [];
            if (!this.bucketList.length) {
                this.selectedBucket = "";
                this.$store.dispatch('setBreadcrumbs', []);
                this.message = `There is no bucket for credential ${this.selectedCredential}`;
            }
            this.dropDownLoading = '';
            this.loading = false;
        },
        onSelectBucket(bucket) {
            let breadcrumbPath = [{
                name: bucket,
                route: {
                    name: "File Browser List",
                    params: {
                        bucket: `${bucket}`,
                        cid: this.$store.state.currentClient.cid,
                        serviceName: SERVICE_NAME
                    }
                }
            }];
            this.$store.dispatch('setBreadcrumbs', breadcrumbPath);
            if (this.selectedBucket !== bucket) {
                this.$store.dispatch('amdp/setFolderPath', "");
            }
        },
        async fetchFileBrowserList(folderPath) {
            this.error = null;
            this.filesList = [];
            this.loading = true;
            if (folderPath && folderPath !== "s3://") {
                let response;
                try {
                    response = await this.getServiceFileBrowserList({
                        serviceName: SERVICE_NAME,
                        namespace: this.$store.state.amdp.selectedCredential,
                        folderName: folderPath
                    });
                } catch (error) {
                    this.filesList = [];
                    this.loading = false;
                    if (error.response?.data?.error) this.error = error.response.data.error;
                    else this.error = error.message;
                    return;
                }
                this.filesList = response.data || [];
            }
            this.loading = false;
        },
        onRefresh() {
            if (this.selectedBucket) {
                this.filesList = [];
                this.fetchFileBrowserList(this.folderPath);
            } else {
                this.dropDownLoading = 'bucket';
                this.bucketList = [];
                this.fetchBucketList(true);
            }
        },
        buildS3Path(fileName) {
            const currentFolderPath = this.$store.state.amdp.folderPath;
            if (currentFolderPath && currentFolderPath !== "s3://") {
                return currentFolderPath + fileName;
            } else {
                const selectedBucket = this.selectedBucket;
                const selectedCredential = this.$store.state.amdp.selectedCredential;
                const cid = this.$store.state.currentClient?.cid;
                if (selectedBucket) {
                    let path = "s3://";
                    if (selectedCredential && cid) {
                        path += `${cid}.${selectedCredential}@`;
                    }
                    path += `${selectedBucket}/${fileName}`;
                    return path;
                }
            }
            return fileName;
        },
        async fetchPresignURL(S3Path) {
            this.loading = true;
            let response;
            try {
                response = await this.getServicePresignURL({
                    serviceName: SERVICE_NAME,
                    namespace: this.$store.state.amdp.selectedCredential,
                    filePath: S3Path,
                    operation: "download"
                });
            } catch (error) {
                this.loading = false;
                if (error.response?.data?.error) this.error = error.response.data.error;
                else this.error = error.message;
                return;
            }
            let data = response.data;
            this.presignURL = data.url;
            this.$emit('onFileSelect', { presignedUrl: this.presignURL, name: S3Path });
            this.loading = false;
        },
        onBreadcrumbClick() {
            this.fetchFileBrowserList(this.folderPath);
        }
    },
    mounted() {
        console.log("Mounted FileBrowser component with current CID:", this.$store.state.currentClient?.cid);
        this.fetchNamespaces();
    },
    emits: ['onFileSelect', 'onFileClicked']
}
</script>

<style>

</style>
